import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { DocenteService } from 'src/app/services/docente-service'
import { RelatorioEntregue } from 'src/app/models/relatorio-entregue'
import { UnespCoreUserService } from '@unesp/core'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { MatDialog } from '@angular/material/dialog'
import { PdfViewerComponent } from '../../comum/pdf-viewer/pdf-viewer.component'
import { DataService } from 'src/app/services/data-service'
import { StorageFolder } from 'src/app/enums/storage-folder'

@Component({
  selector: 'app-docente-relatorio-entregue',
  templateUrl: './docente-relatorio-entregue.component.html',
  styleUrls: ['./docente-relatorio-entregue.component.css'],
  standalone: false
})
export class DocenteRelatorioEntregueComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = [
    'id',
    'nome',
    'programa',
    'nomeDisciplina',
    'codigoDisciplina',
    'semestre',
    'relatorioHomologado',
    'action',
  ]
  dataSource: MatTableDataSource<RelatorioEntregue> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  idDocenteSecao: number = 0
  cpf: string = ''

  constructor(
    private docenteService: DocenteService,
    private unespCoreUserService: UnespCoreUserService,
    public dialog: MatDialog,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
    this.unespCoreUserService.user$.subscribe(user => {
      this.idDocenteSecao = (user as UsuarioLogin).idLotacaoOficial ?? 0
      this.cpf = (user as UsuarioLogin).cpf ?? 0
      this.getData()
    })
  }

  getData(): void {
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    this.docenteService.relatorioEntregue(this.idDocenteSecao, this.cpf, this.anoSelecionado).subscribe(data => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  download(row: RelatorioEntregue): void {
    this.docenteService.download(StorageFolder.relatorio, row.id).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf',
      })
      let url = window.URL.createObjectURL(blob)
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: row.nome,
          url: url,
        },
        width: '80%',
        height: '90%',
      })
    })
  }
}
